/* T102U Mantram360 / reference-layout behaviour: hero + scroll carousels, drawer, dropdown touch, wishlist (localStorage), share, add-to-cart toast,
   product variants + thumbnails, cart quantity steppers, login/recover toggle. No dependencies. */
(function () {
  'use strict';
  var d = document, $ = function (s, r) { return (r || d).querySelector(s); }, $$ = function (s, r) { return [].slice.call((r || d).querySelectorAll(s)); };
  var KEY = 'sd-wishlist';
  function wl() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function saveWl(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} paintWl(); }
  function paintWl() {
    var a = wl();
    $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', a.indexOf(b.getAttribute('data-wish')) > -1 ? 'true' : 'false'); });
    $$('[data-wish-count]').forEach(function (n) { n.textContent = a.length; });
  }
  function money(c) { return '₹ ' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function toast(html) {
    var t = $('.sd-toast'); if (t) t.remove();
    t = d.createElement('div'); t.className = 'sd-toast'; t.setAttribute('role', 'status'); t.innerHTML = html; d.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4500);
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    var w = t.closest('[data-wish]');
    if (w) { e.preventDefault(); var h = w.getAttribute('data-wish'), a = wl(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.push(h); saveWl(a); return; }
    if (t.closest('[data-sd-open]')) { var dr = $('[data-sd-drawer]'); if (dr) dr.hidden = false; return; }
    if (t.closest('[data-sd-close]')) { var dr2 = $('[data-sd-drawer]'); if (dr2) dr2.hidden = true; return; }
    var nx = t.closest('[data-sd-scroll-next]');
    if (nx) { var l = $('[data-sd-scroll]'); if (l) l.scrollBy({ left: 400, behavior: 'smooth' }); return; }
    var car = t.closest('[data-sd-car]');
    if (car && (t.closest('[data-sd-prev]') || t.closest('[data-sd-next]'))) {
      var tr = $('.sd-car__track', car), dir = t.closest('[data-sd-next]') ? 1 : -1;
      tr.scrollBy({ left: dir * Math.max(240, tr.clientWidth * .85), behavior: 'smooth' }); return;
    }
    var dd = t.closest('.sd-has-drop > a:not([data-sd-drop-toggle])');
    if (dd && window.matchMedia('(hover: none)').matches) { var li = dd.parentNode; if (!li.classList.contains('is-open')) { e.preventDefault(); $$('.sd-has-drop.is-open').forEach(function (x) { x.classList.remove('is-open'); }); li.classList.add('is-open'); } return; }
    if (!t.closest('.sd-has-drop')) $$('.sd-has-drop.is-open').forEach(function (x) { x.classList.remove('is-open'); });
    var sb = t.closest('[data-sd-share-btn]');
    if (sb) { var m = $('.sd-share__menu'); m.hidden = !m.hidden; sb.setAttribute('aria-expanded', String(!m.hidden)); return; }
    if (t.closest('[data-sd-copy]')) { try { navigator.clipboard.writeText(location.href); toast('Link copied'); } catch (er) {} var mm = $('.sd-share__menu'); if (mm) mm.hidden = true; return; }
    var tg = t.closest('[data-sd-toggle]');
    if (tg) { e.preventDefault(); var rec = tg.getAttribute('data-sd-toggle') === 'recover'; $('#sd-login').hidden = rec; $('#sd-recover').hidden = !rec; return; }
    var q = t.closest('[data-qty]');
    if (q) { var inp = $('[data-qty-input]', q.parentNode), v = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(q.getAttribute('data-qty'), 10)); inp.value = v; sdCartQty(inp); return; }
    var th = t.closest('[data-sd-thumb]');
    if (th) { pdpGo(parseInt(th.getAttribute('data-sd-thumb'), 10) || 0); return; }
    var pd = t.closest('[data-sd-pdp-dot]');
    if (pd) { pdpGo(parseInt(pd.getAttribute('data-sd-pdp-dot'), 10) || 0); return; }
    if (t.closest('[data-sd-pdp-prev]')) { pdpGo(pdpIndex() - 1); return; }
    if (t.closest('[data-sd-pdp-next]')) { pdpGo(pdpIndex() + 1); return; }
  });
  // T109 product photo carousel: thumbs, dots, prev/next and variant changes scroll the track; scrolling updates thumb, dot and zoom link
  function pdpTrack() { return $('[data-sd-pdp-track]'); }
  function pdpIndex() { var tr = pdpTrack(); return tr && tr.clientWidth ? Math.round(tr.scrollLeft / tr.clientWidth) : 0; }
  function pdpGo(i) {
    var tr = pdpTrack(); if (!tr) return;
    var n = tr.children.length; i = Math.max(0, Math.min(n - 1, i));
    tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); pdpPaint(i);
  }
  function pdpPaint(i) {
    var tr = pdpTrack(); if (!tr) return;
    $$('[data-sd-thumb]').forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
    $$('[data-sd-pdp-dot]').forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
    var s = tr.children[i], z = $('#sd-pdp-zoom');
    if (s && z && s.getAttribute('data-full')) z.href = s.getAttribute('data-full');
  }
  (function () {
    var tr = pdpTrack(), raf = 0; if (!tr) return;
    tr.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; pdpPaint(pdpIndex()); }); }, { passive: true });
  })();
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var dr = $('[data-sd-drawer]'); if (dr) dr.hidden = true; var m = $('.sd-share__menu'); if (m) m.hidden = true; } });

  // add to cart from cards and the product page (T106): ajax + badge + toast, falls back to normal form post. Buy Now still posts to checkout.
  function cartCount(n) { $$('[data-sd-cart-count]').forEach(function (b) { b.textContent = n; }); $$('.sd-bub__n').forEach(function (b) { if (b.hasAttribute('data-sd-cart-count')) return; var x = b.querySelector('xo-cart-size'); if (x) x.textContent = n; else if (!b.hasAttribute('data-wish-count')) b.textContent = n; }); }
  var lastSub = null; d.addEventListener('click', function (e) { lastSub = e.target.closest && e.target.closest('button[type=submit]'); }, true); // browsers without e.submitter
  d.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-sd-add], [data-pdp-form], .sd-pdp__form');
    if (!f || !window.fetch || f.hasAttribute('data-sd-native')) return;
    var sub = 'submitter' in e ? e.submitter : lastSub; if (sub && sub.name === 'return_to') return;
    e.preventDefault();
    var btn = $('[data-sd-atc]', f) || $('[type=submit]', f); if (btn) btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js').then(function (c) { return c.json(); }); })
      .then(function (c) { if (btn) btn.removeAttribute('aria-busy'); cartCount(c.item_count); toast('Added to cart <a href="/cart">View cart</a>'); })
      .catch(function () { f.setAttribute('data-sd-native', ''); f.removeAttribute('data-sd-add'); f.submit(); });
  });
  d.addEventListener('change', function (e) { if (e.target.matches('[data-qty-input]') && e.target.form) { /* user presses Update cart */ } });

  // hero
  $$('[data-sd-hero]').forEach(function (h) {
    var slides = $$('.sd-slide', h), dots = $$('[data-sd-dot]', h), i = 0, speed = (parseInt(h.getAttribute('data-speed'), 10) || 6) * 1000, timer;
    function ok(k) { return slides[k].offsetParent !== null; } // phone-only banners are display:none on wide screens
    function go(n, dir) { dir = dir || 1; n = (n + slides.length) % slides.length; for (var g = 0; g < slides.length && !ok(n); g++) n = (n + dir + slides.length) % slides.length; i = n; slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); }); dots.forEach(function (x, k) { x.classList.toggle('is-on', k === i); }); }
    function run() { clearInterval(timer); if (slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { go(i + 1); }, speed); }
    h.addEventListener('click', function (e) { var t = e.target;
      if (t.closest('[data-sd-prev]')) { e.preventDefault(); go(i - 1, -1); run(); }
      else if (t.closest('[data-sd-next]')) { e.preventDefault(); go(i + 1); run(); }
      else if (t.closest('[data-sd-dot]')) { e.preventDefault(); go(parseInt(t.closest('[data-sd-dot]').getAttribute('data-sd-dot'), 10)); run(); } });
    if (slides.length < 2) $$('.sd-hero__arrow, .sd-hero__dots', h).forEach(function (x) { x.hidden = true; });
    run();
  });

  // product variants
  $$('[data-sd-pdp]').forEach(function (p) {
    var js = $('[data-sd-variants]', p); if (!js) return;
    var vs = JSON.parse(js.textContent), fs = $$('[data-sd-opt]', p); if (!fs.length) return;
    function pick() {
      var sel = fs.map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
      var v = vs.filter(function (x) { return sel.every(function (s, k) { return x['option' + (k + 1)] === s; }); })[0]; if (!v) return;
      $('[data-sd-variant-id]', p).value = v.id;
      $('[data-sd-price]', p).textContent = money(v.price);
      var was = $('[data-sd-was]', p); if (was) { var on = v.compare_at_price && v.compare_at_price > v.price; was.hidden = !on; was.textContent = on ? money(v.compare_at_price) : ''; }
      var av = $('[data-sd-avail]', p); av.innerHTML = v.available ? '<span class="sd-avail__in">&#9679; Availability: In Stock</span>' : '<span class="sd-avail__out">&#9679; Availability: Out of Stock</span>';
      $('[data-sd-atc]', p).disabled = !v.available; $('[data-sd-buy]', p).disabled = !v.available;
      $('[data-sd-atc] span', p).textContent = v.available ? 'Add to Cart' : 'Sold out';
      if (v.featured_media) { var sl = $$('.sd-pdp__slide', p), k = sl.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.featured_media.id)); if (k > -1) pdpGo(k); }
      if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
    }
    fs.forEach(function (f) { f.addEventListener('change', pick); });
  });

  // wishlist page
  var grid = $('[data-sd-wish-grid]');
  if (grid) {
    var a = wl(), empty = $('[data-sd-wish-empty]');
    if (a.length) {
      Promise.all(a.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (ps) {
        ps = ps.filter(Boolean); if (!ps.length) return;
        grid.innerHTML = ps.map(function (p) {
          var img = p.featured_image ? '<img class="sd-card__img" src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') + '" alt="" loading="lazy">' : '';
          return '<li class="sd-card-item"><article class="sd-card"><div class="sd-card__frame"><a class="sd-card__media" href="' + p.url + '">' + img + '</a><button type="button" class="sd-card__wish" data-wish="' + p.handle + '" aria-pressed="true" aria-label="Remove from wishlist">&#9825;</button></div><div class="sd-card__body"><h3 class="sd-card__title"><a href="' + p.url + '">' + p.title.replace(/</g, '&lt;') + '</a></h3><p class="sd-card__price"><span class="sd-card__now">' + money(p.price) + '</span>' + (function () { var lo = (p.variants || []).filter(function (x) { return x.price === p.price; })[0]; return lo && lo.compare_at_price > lo.price ? ' <s class="sd-card__was">' + money(lo.compare_at_price) + '</s>' : ''; })() + '</p><div class="sd-card__btns"><a class="sd-btn sd-btn--fill" href="' + p.url + '">View product</a></div></div></article></li>';
        }).join('');
        grid.hidden = false; if (empty) empty.hidden = true;
      });
    }
  }

  // lazy image fade-in marker
  function mark(i) { i.classList.add('is-loaded'); }
  d.addEventListener('load', function (e) { if (e.target.tagName === 'IMG') mark(e.target); }, true);
  $$('img').forEach(function (i) { if (i.complete) mark(i); });
  setTimeout(function () { $$('img').forEach(mark); }, 4000);
  var fl = $('.sd-filter'); if (fl && matchMedia('(max-width: 767px)').matches) fl.open = false;
  var ft = $('[data-sd-filter-toggle]'); if (ft && fl) ft.addEventListener('click', function () { fl.open = !fl.open; fl.classList.toggle('is-shown', fl.open); }); /* T104 */
  paintWl();
})();

/* T109 category bar: a top link with sub-categories opens/closes its dropdown on click instead of navigating;
   click outside or Escape closes it. All Collections and links without children stay normal links. */
(function () {
  'use strict';
  var d = document;
  function close(except) {
    [].slice.call(d.querySelectorAll('.sd-has-drop.is-open')).forEach(function (li) {
      if (li === except) return;
      li.classList.remove('is-open');
      var a = li.querySelector('[data-sd-drop-toggle]'); if (a) a.setAttribute('aria-expanded', 'false');
    });
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sd-drop-toggle]');
    if (a) {
      if (window.matchMedia('(max-width: 899px)').matches) return; // T109 QA: phones hide the dropdown, so the tap navigates
      e.preventDefault();
      var li = a.parentNode, open = !li.classList.contains('is-open');
      close(li);
      li.classList.toggle('is-open', open);
      a.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!(e.target.closest && e.target.closest('.sd-has-drop'))) close();
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var ae = d.activeElement; close(); if (ae && ae.closest && ae.closest('.sd-has-drop')) ae.blur(); } });
  // T109 QA: place the fixed dropdown under its top link (desktop), so the scrolling bar can't clip it.
  var wide = window.matchMedia('(min-width: 900px)');
  function place(li) {
    var dr = li && li.querySelector(':scope > .sd-drop'); if (!dr || !wide.matches) return;
    var r = li.getBoundingClientRect(), w = Math.max(dr.offsetWidth, 220);
    dr.style.top = Math.round(r.bottom) + 'px';
    dr.style.left = Math.round(Math.max(8, Math.min(r.left, window.innerWidth - w - 8))) + 'px';
  }
  [].forEach.call(d.querySelectorAll('.sd-bar .sd-has-drop'), function (li) {
    li.addEventListener('mouseenter', function () { place(li); });
    li.addEventListener('focusin', function () { place(li); });
    li.addEventListener('click', function () { requestAnimationFrame(function () { place(li); }); });
  });
  function replace() { [].forEach.call(d.querySelectorAll('.sd-bar .sd-has-drop:hover, .sd-bar .sd-has-drop:focus-within, .sd-bar .sd-has-drop.is-open'), place); }
  window.addEventListener('scroll', replace, { passive: true }); window.addEventListener('resize', replace);
  var bl = d.querySelector('.sd-bar__list'); if (bl) bl.addEventListener('scroll', replace, { passive: true });
})();

/* T109 category/search infinite scroll: the next page's cards are appended into the grid as the sentinel nears the viewport;
   sd-pagination stays in the markup as the no-JS fallback and comes back if a load fails. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  [].slice.call(document.querySelectorAll('[data-sd-more]')).forEach(function (more) {
    var box = more.parentNode, grid = box.querySelector('[data-sd-grid]'), pager = box.querySelector('[data-sd-pager]'), busy = false;
    if (!grid) return;
    if (pager) pager.hidden = true;
    var seen = {}; seen[location.href] = 1;
    function fail() { io.disconnect(); more.remove(); if (pager) pager.hidden = false; }
    var io = new IntersectionObserver(function (entries) {
      if (busy || !entries.some(function (e) { return e.isIntersecting; })) return;
      var url = more.getAttribute('data-next');
      if (!url) return fail();
      var abs = new URL(url, location.href).href; if (seen[abs]) { io.disconnect(); more.remove(); return; } seen[abs] = 1;
      busy = true;
      fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), g = doc.querySelector('[data-sd-grid]'), nx = doc.querySelector('[data-sd-more]'), wl = [];
        try { wl = JSON.parse(localStorage.getItem('sd-wishlist') || '[]'); } catch (e) {}
        if (g) [].slice.call(g.children).forEach(function (li) {
          if (li.tagName !== 'LI') return;
          var a = li.querySelector('a[href*="/products/"]'), k = a && a.getAttribute('href').split('?')[0];
          if (k) { if (grid.querySelector('a[href^="' + k + '"]')) return; }
          li = document.importNode(li, true);
          [].slice.call(li.querySelectorAll('[data-wish]')).forEach(function (b) { b.setAttribute('aria-pressed', wl.indexOf(b.getAttribute('data-wish')) > -1 ? 'true' : 'false'); });
          grid.appendChild(li);
        });
        if (nx && nx.getAttribute('data-next')) {
          more.setAttribute('data-next', nx.getAttribute('data-next')); busy = false;
          io.unobserve(more); io.observe(more); // re-check: the sentinel may still be inside the 600px margin
        } else { io.disconnect(); more.remove(); }
      }).catch(fail);
    }, { rootMargin: '600px 0px' });
    io.observe(more);
  });
})();

// T109 P0: cart qty +/- and typed quantities update the real cart (/cart/change.js by line), then the cart form and header count are refreshed from /cart.
var sdCartT = {};
function sdCartQty(inp) {
  var line = parseInt(inp.getAttribute('data-line'), 10); if (!line || !inp.closest('[data-sd-cart]')) return;
  clearTimeout(sdCartT[line]);
  sdCartT[line] = setTimeout(function () {
    var form = inp.closest('[data-sd-cart]'); form.setAttribute('aria-busy', 'true');
    fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, parseInt(inp.value, 10) || 0) }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (cart) {
        [].forEach.call(document.querySelectorAll('xo-cart-size, [data-sd-cart-count]'), function (n) { n.textContent = cart.item_count; });
        return fetch(location.pathname + location.search, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'), nf = doc.querySelector('[data-sd-cart]'), old = document.querySelector('[data-sd-cart]');
          if (nf && old) old.innerHTML = nf.innerHTML; else if (!cart.item_count) location.reload();
        });
      })
      .catch(function () { form.removeAttribute('aria-busy'); form.submit(); })
      .then(function () { var f = document.querySelector('[data-sd-cart]'); if (f) f.removeAttribute('aria-busy'); });
  }, 350);
}
document.addEventListener('change', function (e) { var t = e.target; if (t && t.matches && t.matches('[data-qty-input]')) sdCartQty(t); });
